/**
 * 表单验证规则
 */
import { Rule } from 'antd/es/form';
import { TFunction } from 'i18next';

// 创建一个函数来获取带有翻译的验证规则
export const getTranslatedValidationRules = (t: TFunction) => {
  return {
    // 必填项规则
    required: { required: true, message: t('category.validation.required') },
    
    // 编码规则
    code: [
      { required: true, message: t('category.validation.codeRequired') },
      { pattern: /^[A-Za-z0-9-_]+$/, message: t('category.validation.codePattern') },
      { max: 50, message: t('category.validation.codeMaxLength') }
    ] as Rule[],
    
    // 名称规则
    name: [
      { required: true, message: t('category.validation.nameRequired') },
      { max: 100, message: t('category.validation.nameMaxLength') }
    ] as Rule[],
    
    // 备注规则
    remark: [
      { max: 500, message: t('category.validation.remarkMaxLength') }
    ] as Rule[],
    
    // 类目规则
    categories: [
      { required: true, message: t('category.validation.categoriesRequired') },
      { type: "array" }
    ] as Rule[],
    
    // 主要事业部规则
    mainDivision: [
      { required: true, message: t('category.validation.mainDivisionRequired') }
    ] as Rule[]
  };
};

// 保持原有的验证规则对象，但使用国际化键值
export const VALIDATION_RULES: Record<string, Rule | Rule[]> = {
  // 必填项规则
  required: { required: true, message: 'category.validation.required' },
  
  // 编码规则
  code: [
    { required: true, message: 'category.validation.codeRequired' },
    { pattern: /^[A-Za-z0-9-_]+$/, message: 'category.validation.codePattern' },
    { max: 50, message: 'category.validation.codeMaxLength' }
  ] as Rule[],
  
  // 名称规则
  name: [
    { required: true, message: 'category.validation.nameRequired' },
    { max: 100, message: 'category.validation.nameMaxLength' }
  ] as Rule[],
  
  // 备注规则
  remark: [
    { max: 500, message: 'category.validation.remarkMaxLength' }
  ] as Rule[],
  
  // 类目规则
  categories: [
    { required: true, message: 'category.validation.categoriesRequired' },
    { type: "array" }
  ] as Rule[],
  
  // 主要事业部规则
  mainDivision: [
    { required: true, message: 'category.validation.mainDivisionRequired' }
  ] as Rule[]
};